<template>
  <div>
    <div v-if="currentlyActive" class="tab-bar-grid-layout">
      <div>
        <Tab :active="true" :text="'Already have an account?'" />
      </div>
      <div>
        <Tab
          :active="false"
          :text="'Need to open an account?'"
          @switch-tab="switchTab"
        />
      </div>
    </div>
    <div v-else class="tab-bar-grid-layout">
      <div>
        <Tab
          :active="false"
          :text="'Already have an account?'"
          @switch-tab="switchTab"
        />
      </div>
      <div>
        <Tab :active="true" :text="'Need to open an account?'" />
      </div>
    </div>
    <div class="grid-area-number-2 animate-left" v-if="currentlyActive">
      <div>
        <ManageYourAccountSection />
      </div>
      <VerticalDivider class="existing-divider" style="height: 2px" />
      <div>
        <FindYourProvider />
      </div>
    </div>
    <div class="grid-area-number-2 animate-right" v-else>
      <PatientLendingProgramsSection />
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../../../Shared/utils/event-bus";
import Tab from "./Tab.vue";
import ManageYourAccountSection from "@/components/LandingPage/ManageYourAccountSection.vue";
import PatientLendingProgramsSection from "@/components/LandingPage/PatientLendingProgramsSection.vue";
import FindYourProvider from "@/components/LandingPage/FindYourProvider.vue";
import VerticalDivider from "@Shared/components/VerticalDivider.vue";

export default {
  name: "PatientEnrollmentTab",
  components: {
    Tab,
    ManageYourAccountSection,
    PatientLendingProgramsSection,
    FindYourProvider,
    VerticalDivider,
  },
  data() {
    return {
      currentlyActive: true,
    };
  },
  methods: {
    switchTab() {
      this.currentlyActive = !this.currentlyActive;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-bar-grid-layout {
  display: grid;
  grid-template-columns: repeat(2, auto);
  margin: 5vh 10vh;

  @media all and (max-width: $grid-breakpoint-md) {
    display: grid;
    grid-template-columns: repeat(2, auto);
    margin: 2vh 2vh;
  }

  @media all and (max-width: $grid-breakpoint-lg) {
    display: grid;
    grid-template-columns: repeat(2, auto);
    margin: 2vh 3vh;
  }
}

.existing-divider {
  margin: 100px 25px 50px 25px;

  @media all and (max-width: $grid-breakpoint-md) {
    margin: 100px 25px 15px 25px;
  }
}

.animate-right {
  position: relative;
  animation: animateright 0.6s 1 ease-out;
}
@keyframes animateright {
  from {
    right: -600px;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}
.animate-left {
  position: relative;
  animation: animateleft 0.6s 1 ease-out;
}
@keyframes animateleft {
  from {
    left: -600px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}
</style>
